<template>
  <div>
    <copy-periods
      :window-visible="windowVisible"
      @close="closeModal"
      @save="closeAndRefresh"
    ></copy-periods>
    <page-toolbar>
      <kendo-button icon="add" title="Add row" @click="addRecord" v-if="!isReadOnly">
      </kendo-button>
      <kendo-button
        icon="copy"
        title="Copy from"
        @click="toggleModal"
        v-if="!isReadOnly"
      ></kendo-button>
    </page-toolbar>
    <div style="height:calc(100vh - 170px)" ref="periodGrid"></div>
  </div>
</template>
<script>
import $ from '@/helpers/jquery-bridge'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '@/helpers/export-helper'
import notification from '@/helpers/notification'
import {checkboxColumn} from '@/helpers/kendo-editors'
import CopyPeriods from './CopyPeriods'
import security from '@/mixins/security'

export default {
  name: 'Period',
  mixins: [security],
  components: {
    PageToolbar,
    CopyPeriods,
  },
  mounted() {
    let grid = $(this.$refs.periodGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 12,
          transport: {
            create: {
              type: 'POST',
              url: '/api/config/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
              complete: () => {
                this.periodGrid.dataSource.read()
              },
            },
            read: {
              type: 'GET',
              url: '/api/config/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            update: {
              type: 'PUT',
              url: '/api/config/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
              complete: () => {
                this.periodGrid.dataSource.read()
              },
            },
            destroy: {
              type: 'DELETE',
              url: '/api/config/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
              complete: () => {
                this.periodGrid.dataSource.read()
              },
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'periodId',
              fields: {
                CalendarId: {field: 'calendarId', type: 'number', defaultValue: 0},
                PeriodYear: {field: 'periodYear', type: 'number'},
                Code: {field: 'code', type: 'string', editable: true},
                StartDate: {field: 'startDate', type: 'date', editable: true},
                EndDate: {field: 'endDate', type: 'date', editable: true},
                IsClosed: {
                  field: 'isClosed',
                  type: 'bool',
                  defaultValue: false,
                  editable: !this.isReadOnly,
                },
                IsVisible: {
                  field: 'isVisible',
                  type: 'bool',
                  defaultValue: true,
                  editable: !this.isReadOnly,
                },
                CalendarCode: {field: 'calendarCode', type: 'string', editable: true},
                CanDelete: {field: 'canDelete', type: 'bool', defaultValue: true, editable: false},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              if (e.action == 'sync') {
                e.sender.cancelChanges()
              }
              e.preventDefault()
            })
          },
        }),
        edit: function(e) {
          if (!e.model.isNew()) {
            return
          }
          var itemsTotal = grid.dataSource.total()

          $.get('/api/config/period/getNextPeriod', {clientId: this.clientId}, function(response) {
            if (response != null) {
              var code = response.code
              var periodYear = response.periodYear
              var startDate = response.startDate
              var endDate = response.endDate

              if (itemsTotal > 1) {
                e.model.set('Code', code)
              }
              e.model.set('PeriodYear', periodYear)
              e.model.set('StartDate', startDate)
              e.model.set('EndDate', endDate)
            }
          })
        }.bind(this), //Note:binding this from vue model
        editable: !this.isReadOnly ? 'inline' : false,
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {command: 'edit', title: '&nbsp;', width: 60, hidden: this.isReadOnly},
          {
            field: 'Code',
            title: 'Code',
            width: 150,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:d}',
            editor: function(container) {
              container.html('<span data-bind="text: Code"></span>')
            },
            template: '#=Code#',
          },
          {
            field: 'PeriodYear',
            title: 'Period Year',
            width: 120,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: right;'},
            format: '{0:0}',
          },
          {
            field: 'StartDate',
            title: 'StartDate',
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(StartDate, "yyyy-MM-dd") #',
            width: 200,
          },
          {
            field: 'EndDate',
            title: 'EndDate',
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(EndDate, "yyyy-MM-dd") #',
            width: 200,
          },
          checkboxColumn(
            'IsClosed',
            {
              title: 'Closed',
              width: 100,
            },
            this.isReadOnly,
          ),
          checkboxColumn(
            'IsVisible',
            {
              title: 'Visible',
              width: 82,
            },
            this.isReadOnly,
          ),
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.CanDelete}],
            width: 82,
            attributes: {style: 'text-align: center;'},
            hidden: this.isReadOnly,
          },
          {},
        ],
      })
      .data('kendoGrid')

    enableExportExcel(grid, '/api/config/period/exportToExcel', $('.page_toolbar-item'))
    this.periodGrid = grid
  },
  data() {
    return {
      windowVisible: false,
      periodGrid: {},
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  methods: {
    addRecord() {
      this.periodGrid.addRow()
    },
    toggleModal() {
      var totalRecords = this.periodGrid.dataSource.total()
      if (totalRecords === 0) {
        this.windowVisible = !this.windowVisible
      } else {
        notification('Delete all periods before copying from another client.', 'error')
      }
    },
    openModal() {
      this.windowVisible = true
    },
    closeModal() {
      this.windowVisible = false
    },
    closeAndRefresh() {
      this.periodGrid.dataSource.read()
      this.closeModal()
    },
  },
}
</script>
<style></style>
